import React, { useEffect } from 'react';
import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from 'antd';
import KanbanCard from './KanbanCard';
import RoutePage from './RoutePage';
import StAddNew from '../pages/DSeries/StAddNew';
import ZenMenu from './ZenMenu';
import ZenPopScanter from './ZenPopScanter';
import ZenMultiScanter from './ZenMultiScanter';

const ZenModal = ({ scanterCallback, modal, toggleModal, zenModal, smodalCallback, refreshData }) => {


    const modalTitles = zenModal?.title || zenModal?.modalHeader || zenModal?.pageTitle || 'noTitle';
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const KanBanModal = modal?.type === 'kanban' && (
        <KanbanCard cardData={modal?.data} />
    )

    const ZenMenuModal = modal?.type === 'zenMenu' && (
        <ZenMenu
            recordData={{ ...modal?.data?.record }}
            togglePrevModal={toggleModal}
            menu={[...modal?.data?.data]}
            refreshData={(params) => { refreshData(params); toggleModal({}); }}
        />
    )

    const scanter = modal?.type === 'scanter' && (
        <ZenPopScanter
            scanter={modal?.data?.scanter}
            method={modal?.data?.method}
            api={modal?.data?.api}
            urlData={modal?.data?.urlData}
            scanterCallback={scanterCallback}
        />
    )
    const multiScanter = modal?.type === 'multiScanter' && (
        <ZenMultiScanter
            method={modal?.data?.method}
            api={modal?.data?.api}
            urlData={modal?.data?.urlData}
            scanterCallback={scanterCallback}
        />
    )

    const sModal = modal?.type === 'smodal' && (
        <StAddNew
            colSpan={24}
            urlEndpoint={zenModal?.api}
            extraData={modal?.data?.urlData || { id: modal?.data?.id }}
            urlData={modal?.data?.urlData || { id: modal?.data?.id, dictName: zenModal?.params?.dictName }}
            submitTxt="Save"
            onCallFinish={({ data }) => {
                toggleModal({});
                if (smodalCallback) {
                    smodalCallback({ data: data?.data, onlyPostSubmitAction: true });
                }
            }}
        />
    );

    const popupModal = () => {
        if (modal?.type === 'popUpModal') {
            let zenModalData = { ...zenModal };
            let __modalElements = [...zenModalData?.modalElements];
            __modalElements.forEach(x => {
                x.default = modal?.data[x.data_index] || x.default;
            });
            zenModalData.modalElements = __modalElements;
            return (
                <>
                    <StAddNew
                        colSpan={24}
                        popUpModal={zenModalData}
                        extraData={{ ...modal?.data?.urlData }}
                        urlData={modal?.data?.urlData || { id: modal?.data?.id, dictName: zenModal?.params?.dictName }}
                        submitTxt="Save"
                        onCallFinish={({ data }) => {
                            toggleModal({});
                            if (smodalCallback) {
                                smodalCallback({ data: data?.data, loopToNextRow: zenModal?.loopToNextRow });
                            }
                        }}
                    />
                </>
            )
        }
    }


    const imgViewer = modal.type === 'image' && (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: 'auto', margin: '0 auto', padding: 8 }}>
            <img src={modal?.data} alt="" style={{ width: '100%', height: '100%' }} />
        </div>
        // <ImageViewer visible={modal?.show} imgUrl={modal?.data} hideModal={toggleModal} loading={modal?.loading} />
    );

    const timeline = modal.type === 'timeLine' && (
        modal?.data?.map(x => (
            <div className='timeline-popup' style={{ borderBottom: '0.5px solid #ffffff' }}>
                <div className='date-container'>
                    <p className='date' style={{ marginBottom: 0 }}>{x.dt}</p>
                </div>
                <div className='timeline-mesage-container'>
                    <span className='timeline-icon'>
                        <i className={`fa ${x.icon}`}></i>
                    </span>
                    <p className='timeline-message' style={{ marginBottom: 0 }}>{x.msg}</p>
                </div>
            </div>
        ))
    )

    const getModalClass = () => {
        let cls = 'zen-modal';
        if (modal.type === 'kanban') cls = 'kanban-modal';
        if (modalTitles === 'noTitle') cls += ' modal-no-title';
        return cls;
    }

    const componentByRoute = modal.type === 'route' && (
        <RoutePage style={{ width: zenModal?.width }} route={zenModal?.route} params={modal?.data?.urlData || zenModal?.params} divId={zenModal?.divId} />
    )

    return (
        <>
            {
                modal.show ?
                    <Modal maskClosable={false} footer={modal.type === 'timeLine' ? null : ""} width={zenModal?.width} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} title={modalTitles} style={{ backgroundColor: zenModal?.background || '' }} className={getModalClass()} open={modal.show} onOk={toggleModal} onCancel={toggleModal}>
                        {
                            modal.loading ? (
                                <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                    {antIcon}
                                </div>
                            ) : (
                                <>
                                    {KanBanModal}
                                    {imgViewer}
                                    {componentByRoute}
                                    {sModal}
                                    {popupModal()}
                                    {timeline}
                                    {ZenMenuModal}
                                    {scanter}
                                    {multiScanter}
                                </>
                            )
                        }
                    </Modal> : <></>
            }
        </>
    )
};

export default ZenModal;